import { useReducer, useEffect } from 'react';

const reducer = (subscribers, key) => {
	subscribers.delete(key);
	return new Set(subscribers);
};

export const useLoadingListener = (
	keys: string[],
	onAllLoad: () => void,
	timeout: number = 6000,
) => {
	const [subscribers, dispatch] = useReducer(reducer, new Set(keys));

	useEffect(() => {
		const timer = setTimeout(onAllLoad, timeout);
		return () => clearTimeout(timer);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (subscribers.size === 0) onAllLoad();
		//todo: onAllLoad args should be added to dep array but it needs to be passed as a ref in the files where it's called from
		//try wrapping usages in useCallback rather than passing inline functions as args.
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [subscribers]);

	return dispatch;
};
